// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationBackspacePath = 'M100 14.5v71H34.712a15.992 15.992 0 01-12.623-6.173L1.264 52.558a6.002 6.002 0 01.137-7.539l20.774-24.796A15.992 15.992 0 0134.434 14.5H100zm-65.288 64L93 78.498v-57l-58.568.002a8.995 8.995 0 00-6.542 2.822l-.353.397L7.282 48.895l20.33 26.133a8.996 8.996 0 006.547 3.455l.553.017zM62.472 50l15.025 15.025-4.95 4.95L57.523 54.95 42.497 69.975l-4.95-4.95L52.573 50 37.547 34.975l4.95-4.95L57.522 45.05l15.026-15.025 4.95 4.95L62.471 50z';
var IllustrationBackspace = baseIllustration('IllustrationBackspace', {
  getPath: () => IllustrationBackspacePath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationBackspace;
//# sourceMappingURL=index.js.map